import { useI18n } from 'vue-i18n';
import * as yup from 'yup';
import { CASHLESS_PAY_TYPES } from '../../../components';

export default () => {
  // Set Localization
  const { t } = useI18n();

  const schema = yup.object({
    id: yup.string().nullable().optional(),
    name: yup
      .string()
      .nullable()
      .test({
        name: 'test-empty-string',
        test(value, ctx) {
          if (value?.startsWith(' ')) {
            return ctx.createError({ message: t(`errorMessages.startSpace`) });
          }
          return true;
        },
      })
      .required(t(`errorMessages.required`))
      .max(64, t(`errorMessages.max`, { count: 64 })),
    type: yup.string().nullable().required(t(`errorMessages.required`)),
    voucher_webview: yup
      .string()
      .nullable()
      .url(t(`errorMessages.invalidURL`))
      .required(t(`errorMessages.required`)),
    webview: yup
      .string()
      .nullable()
      .url(t(`errorMessages.invalidURL`))
      .required(t(`errorMessages.required`)),
    freedompay: yup.object().when('type', {
      // FreedomPay keys
      is: (type: string) => type === CASHLESS_PAY_TYPES.FREEDOM_PAY,
      then: yup.object({
        badge_pay_system_key: yup.string().nullable().required(t(`errorMessages.required`)),
      }),
    }),
    tenders: yup
      .array()
      .nullable()
      .when('type', {
        is: (type: string) => type === CASHLESS_PAY_TYPES.FREEDOM_PAY,
        then: yup
          .array()
          .nullable()
          .of(
            yup.object({
              name: yup.string().nullable().required(t(`errorMessages.required`)),
              tax_exempt: yup.boolean().nullable().required(t(`errorMessages.required`)),
              type: yup.string().nullable().required(t(`errorMessages.required`)),
            }),
          )
          .min(1, t(`errorMessages.minValue`, { minValue: 1 }))
          .required(t(`errorMessages.required`)),
      }),
  });

  return { schema };
};
